import { taskGroups, type TaskGroup } from '@till-erp/collab/values';

/**
 * Werte, die der Router schon braucht, bevor er eine Seite nachlädt (Story 7.21: jede Seite ein eigener Teil des
 * Pakets): Pfade und erlaubte Werte in der Adresse. Sie stehen hier statt in der Seite, damit der Router die Seite nicht
 * ins Hauptpaket zieht.
 */

export const SUGGESTIONS_PATH = '/ki-vorschlaege';
export const PLANS_PATH = '/vorhaben';
export const SHOPWARE_IMPORT_PATH = '/artikel/aus-shopware';
/** Testseite der Datensatz-Bausteine (Ticket 1.204), nur Testumgebung. */
export const RECORD_PATTERN_PATH = '/muster/datensatz';
/** Testseite der Eingabe-Bausteine (Ticket 1.215: Datumsfeld, Textfeld, „?“-Hilfe, Auswahlfeld), nur Testumgebung. */
export const INPUT_PATTERN_PATH = '/muster/eingaben';
/** Testseite der Grundstein-Bausteine und Tokens (Ticket 1.241), nur mit Testuhr; ohne Eintrag in der Navigation. */
export const COMPONENT_PATTERN_PATH = '/muster/bausteine';
/** Testseite der kompakten Einstellungen (Ticket 1.258, Baustein C: Reiter im Kopf, Werte-Liste, Chips), nur Testumgebung. */
export const SETTINGS_PATTERN_PATH = '/muster/einstellungen';

/** Reiter der Artikelliste (Story 5.100, `?reiter=`); ohne Angabe bzw. unbekannt: „Artikel“. */
export const ARTICLE_LIST_TABS = ['ausgeblendet'] as const;
export type ArticleListTab = (typeof ARTICLE_LIST_TABS)[number];

/** Reiter von Artikel › Stammdaten (Story 5.9, `?reiter=`). */
export const MASTER_DATA_TABS = ['hersteller', 'eigenschaften', 'kategorien'] as const;
export type MasterDataTab = (typeof MASTER_DATA_TABS)[number];

/** Gruppe von „Heute wichtig“ (Story 2.23, `?gruppe=`); Klärfälle: `cases`. */
export type TaskPageGroup = 'cases' | TaskGroup;

export function isTaskPageGroup(value: unknown): value is TaskPageGroup {
  return value === 'cases' || (typeof value === 'string' && (taskGroups as readonly string[]).includes(value));
}

/** Story 11.32/11.33: Filter der Liste „Versand“ in der Adresse (`/versand?lieferschein=`): alle offenen bzw. nur überfällige. */
export type DeliveryNoteFilter = 'offen' | 'ueberfaellig';
export const DELIVERY_NOTE_FILTERS: readonly DeliveryNoteFilter[] = ['offen', 'ueberfaellig'];

/** Teil der Filter-Ansicht (`?teil=2` = Aufträge 11–20): ganze Zahl ≥ 1, sonst `undefined` (= Teil 1). */
export function parseDeliveryNotePart(value: unknown): number | undefined {
  const n = typeof value === 'number' ? value : typeof value === 'string' && /^\d+$/.test(value.trim()) ? Number(value.trim()) : NaN;
  return Number.isSafeInteger(n) && n >= 1 ? n : undefined;
}
